import modalTemplate from './view.html';
import { NotificationModalController } from './controller';

import { NOTIFICATION_MODAL_CONTROLLER } from '../../const';

class NotificationModal {
    constructor($uibModal) {
        'ngInject';
        this.$uibModal = $uibModal;
        this.modalInstance = null;
    }

    $onInit = () => {
        this.$uibModal;
    };

    open = (notificationId = null, copyId = null) => {
        this.modalInstance = this.$uibModal.open({
            template: modalTemplate,
            bindToController: true,
            controller: NOTIFICATION_MODAL_CONTROLLER,
            controllerAs: '$',
            size: 'lg',
            resolve: {
                notificationId: notificationId,
                copyId: copyId,
            },
            backdrop: 'static',
            keyboard: false,
        });

        return this.modalInstance.result;
    };
}

export {
    NotificationModal,
    NotificationModalController,
};
